// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__Jpslp","faq_section":"styles_faq_section__4u8Bm"};